import { useIsFullWidthCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsFullWidthCategory";
var NARROW_CAT_NAV_PAGE_SIZE = 36;
var CAT_NAV_PAGE_SIZE = 40;
/**
 * Inline banners would replace the space for product tiles. We get the accurate
 * number of replace tiles and then only request the remaining number of tiles.
 */ export var useRequestPageSize = function() {
    var isFullWidthCategory = useIsFullWidthCategory();
    if (isFullWidthCategory) {
        return CAT_NAV_PAGE_SIZE;
    }
    return NARROW_CAT_NAV_PAGE_SIZE;
};
